function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

let adContainer = document.getElementById("and-container");
let closePopupAd = document.getElementById("close-popup-ad");
let openPopupAd = document.getElementById("open-popup-ad");

openPopupAd.onclick = function() {
  adContainer.classList.add("active");
}

closePopupAd.onclick = function() {
  adContainer.classList.remove("active");
  setCookie("popupAd", "false", 2);
}

adContainer.onclick = function() {
  adContainer.classList.remove("active");
  setCookie("popupAd", "false", 2);
}

if(getCookie("popupAd") != "false") {
 window.onload = function() {
   if(!window.location.host.includes("shopify")) {
    setTimeout(function() {
      adContainer.classList.add("active");
    }, 8000);
  }
}; 
}
